import React, {useEffect, useState} from "react";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated/dist/react-select.esm";

/**
 * The select component used to select groups in the search bar and to add groups to a pattern
 * @param userId The id of the user. Don't set this if you want to view all groups
 * @param groupsFilter The current groups selected
 * @param groupsUpdate A function that updates the value of groups filter
 * @param optionsArr An optional field to pass the group options in to that the component doesn't make an api call.
 * @param updatePage an update function run on change. In current implementations I think it reloads a component.
 * @param closePatternDetails An optional function that closes the pattern details screen.
 * @param [excludeInactiveGroups = true] Excludes inactive groups. Only is implemented for the cause where userId exists
 * @param {String} [placeholderText = 'Add groups to this pattern']
 * @return {Element}
 * @constructor
 */
export default function ImprovedGroupInput({userId, groupsFilter, groupsUpdate, optionsArr, updatePage, closePatternDetails, excludeInactiveGroups = true, placeholderText = 'Add groups to this pattern'}) {
    const [isLoading, setIsLoading] = useState(true)
    const [unmappedOptions, setUnmappedOptions] = useState([])
    const [userGroups, setUserGroups] = useState([])

    // responsible for getting the basic options data. This will be called on the first render and when optionsArr is updated
    useEffect(() => {
        if (optionsArr && Array.isArray(optionsArr) && optionsArr.length > 0) {
            setUnmappedOptions(optionsArr)
            setIsLoading(false)
        } else {
            axios.get(apiUrl +'Groups/getGroups')
                .then((response) => {
                    setUnmappedOptions(response.data)
                    setIsLoading(false)
                })
        }
    }, [optionsArr]);

    // responsible for getting a user's groups if the user exists. This will run when userId changes and on first render
    useEffect(() => {
        if (userId) {
            axios.get(apiUrl + 'Groups/getGroupsByUserId?user_id=' + userId)
                .then(response => {
                    setUserGroups(response.data)
                })
        }
    }, [userId])

    // select component animations
    const animatedComponents = makeAnimated();

    const allOptions = unmappedOptions.map(g => ({label: g.group_name, value: g.group_id}))
    let options = []

    if (userId) {
        // only show the user's groups and check if they are set to active in the group
        if (excludeInactiveGroups) {
            options = userGroups.filter(gr => gr.group_user_status === 'Active').map(g => ({label: g.group_name, value: g.group_id}))
        } else {
            options = userGroups.map(g => ({label: g.group_name, value: g.group_id}))
        }
    } else {
        // the case used for the search bar
        options = allOptions;
    }


    // the groups that are currently selected (formatted for the select)
    const groups = allOptions.filter(o => groupsFilter.includes(o.value))


    return <Select
        isMulti
        isSearchable
        placeholder={isLoading ? "Loading groups..." : placeholderText}
        value={groups}
        options={options}
        onChange={(val) => {
            groupsUpdate(val);
            updatePage(0);
            closePatternDetails && closePatternDetails(null);
        }}
        components={animatedComponents}
    />

}